// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detail[data-v-5059684b]{display:flex;justify-content:space-between;align-items:center;padding:10px;border-bottom:1px solid var(--border)}.detail .div[data-v-5059684b]{padding:0 10px 0 10px}.sub-table[data-v-5059684b]{padding:0 40px 0 40px}.sub-banner[data-v-5059684b]{margin:0 40px 0 40px;width:auto}.table-header[data-v-5059684b]{align-items:flex-end}", ""]);
// Exports
module.exports = exports;
